import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "../styles.css";
import Picker from "../components/picker";
import { API } from "../../../config/API";
import { POST } from "../../../utils/apirequest";
function Details() {
  const [section1, setSection1] = useState({}) as any;
  const [section2, setSection2] = useState({}) as any;

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      let obj = {
        screen: "details-screen",
      };
      let url = API.ADVERTISEMENT_LIST;
      let res: any = await POST(url, obj);
      if (res.status) {
        let sec1 = res.data.find(
          (item: any) => item.section === "section1" && item.desktop
        );
        let sec2 = res.data.find(
          (item: any) => item.section === "section2" && item.desktop
        );
        setSection1(sec1);
        setSection2(sec2);
      }
    } catch (err) {
      console.log("err", err);
    }
  };

  return (
    <Container fluid>
      <Row>
        <Col md={8}>
          <div className="addScreen-Detaild">Detaild</div>
          <Row>
            <Col md={6}>
              <div className="addScreen-Related">Related News</div>
            </Col>
            <Col md={6}>
              <div className="addScreen-Related">Related News</div>
            </Col>
          </Row>
        </Col>
        <Col md={4}>
          <br />
          <Picker
            value={section1}
            screen={"home"}
            field={"top"}
            title={"Top Screen"}
            desc={"This add will Show above header"}
            style={{ height: 150 }}
            refresh={() => loadData()}
          />
          <div className="addScreen-Detaild">Related News</div>
          <Picker
            value={section1}
            screen={"home"}
            field={"top"}
            title={"Top Screen"}
            desc={"This add will Show above header"}
            style={{ height: 150 }}
            refresh={() => loadData()}
          />
        </Col>
      </Row>
      <br />
    </Container>
  );
}

export default Details;
